import React, { useEffect, useSyncExternalStore } from 'react';
import { notesApi } from '@/lib/notesApi';

// Customer rate cards (Tag Domain workspace) used to pre-fill Excel rates.
let cards = [];
let loaded = false;
const subs = new Set();
const emit = () => subs.forEach((f) => f());
export async function loadRateCards() {
  try { cards = (await notesApi.get('/notes/tag-workspace/rate-cards')).data || []; } catch { cards = []; }
  loaded = true; emit();
  return cards;
}
const subscribe = (f) => { subs.add(f); return () => subs.delete(f); };
export const useRateCards = () => useSyncExternalStore(subscribe, () => cards);
export const rateCardById = (id) => cards.find((c) => c.id === id) || null;

// Small select for choosing a customer's rate card before an Excel download.
export function RateCardPicker({ value, onChange, className = '', testid = 'rate-card-picker' }) {
  const list = useRateCards();
  useEffect(() => { if (!loaded) loadRateCards(); }, []);
  return (
    <select value={value || ''} onChange={(e) => onChange(e.target.value)} title="Pre-fill Excel rates from a customer's rate card"
      className={`h-9 max-w-[180px] rounded-md border border-slate-200 bg-white px-2 text-xs text-slate-700 ${className}`} data-testid={testid}>
      <option value="">No rate card</option>
      {list.map((c) => <option key={c.id} value={c.id}>Rates: {c.name}</option>)}
    </select>
  );
}
